import { doc, writeBatch } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { PRODUCT_CATEGORIES } from '../constants/entities';

/** Persiste a ordem das categorias de produtos (prateleiras da vitrine). */
export async function persistProductCategoryOrder(orderedCategoryFilters = []) {
  const batch = writeBatch(firestore);
  orderedCategoryFilters.forEach((filter, index) => {
    if (!filter?.value) return;
    batch.update(doc(firestore, PRODUCT_CATEGORIES, filter.value), { order: index + 1 });
  });
  await batch.commit();
}
